module.exports = "/static/assets/30739a9d6fe024c005411f96dfbdfcd1.png";